/***********************************************************
Alexander Self
8/22/17
Gang Edit: Edit user created gangs(teams of employees)
***********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectGangToEdit, removeGangMemberFromEdit, addGangMemberToEdit,
  gangEditAutocomplete, editGang } from '../../../actions/team_actions';
import TeamList from '../view/team_list';
import EmployeeTable from '../../employee_table';
import EmployeeList from '../../employee_list';
import { mapEmployeeForAutoComplete, findEmployeeByName } from '../../../utils';
import { AutoComplete, NumberInput, Select } from '../../inputs';
import { LOCATIONS } from '../../../constants';
const $ = window.$;

class TeamEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gangId: 0,
      gangLoc: 71
    };
  }
  componentDidMount() {
    $(document).ready(function(){
      $('.gang-edit-collapsible').collapsible();
    });
  }
  componentWillReceiveProps(newProps) {
    const gangId = parseInt(newProps.selectedGang.gangId, 10);
    const gangLoc =  newProps.selectedGang.gangLoc;
    if (gangId && gangLoc) {
      this.setState({ gangId, gangLoc }, () => {
        document.getElementById('edit-gang-builder-gangId').value = this.state.gangId;
        document.getElementById('edit-gang-builder-gangLoc').value = this.state.gangLoc;
      });
    }
  }
  render() {
    return (
      <div className="row">
        <blockquote><span className="flow-text">Team Edit</span></blockquote>
        <div className="col s12 m12 l3 xl3">
          <ul className="collapsible gang-edit-collapsible" data-collapsible="accordion">
            <li>
              <div className="collapsible-header"><i className="material-icons">group</i>Teams</div>
              <div className="collapsible-body">
                <div className="emp-list">
                  <div className="card">
                    <TeamList gangs={this.props.gangs} onClick={this.props.selectGangToEdit} />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="collapsible-header"><i className="material-icons">person</i>Employees</div>
              <div className="collapsible-body">
                <AutoComplete id={'employee-gang-edit'} label={'Find Employee'}
                  data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={(val, id) => this.props.gangEditAutocomplete(findEmployeeByName(val, this.props.employees), id)} />
                <div className="emp-list">
                  <div className="card">
                    <EmployeeList employees={this.props.employees} icon={'person_add'} header={'Add Employees'} onClick={(e) => this.props.addGangMemberToEdit(e, this.props.selectedGang)} _class={'green'} />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="col s12 m12 l9 xl9">
          <div className="row">
            <div className="col s12 m4 l3 xl3">
              <NumberInput id={'edit-gang-builder-gangId'} label={'Team No.'} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <Select id={'edit-gang-builder-gangLoc'} opts={LOCATIONS} label={'Team Location'} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <div className="gang-create">Team Count: <b>{ this.props.selectedGang.gangCount }</b></div>
            </div>
            <div className="col s12 m4 l3 xl3">
              <div>
                <button className="btn waves-effect waves-light blue" onClick={() => this.props.editGang(this.props.editedGang)}>Edit Team</button>
              </div>
            </div>
          </div>
           <hr />
          <div className="row">
            <div className="scrollable-edit">
              { this.props.selectedGang.emps.length > 0 ? <EmployeeTable employees={this.props.selectedGang.emps} onClick={this.props.removeGangMemberFromEdit} /> : '' }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    employees: state.gang.employees,
    gangs: state.gang.gangs,
    selectedGang: state.gang.edit.selectedGang,
    editedGang: state.gang.edit
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    selectGangToEdit,
    removeGangMemberFromEdit,
    addGangMemberToEdit,
    gangEditAutocomplete,
    editGang
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamEdit);











































/* END */



// WEBPACK FOOTER //
// ./src/components/teams/edit/team_edit.js